/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Overview_Round_Complete_CheckinInputs */



/**
* | output |
* | --- |
* | "Round {n} complete. Check in players for the next round." |
*
* @param {Overview_Round_Complete_CheckinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_round_complete_checkin = /** @type {((inputs: Overview_Round_Complete_CheckinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Round_Complete_CheckinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} terminée. Pointez les joueurs pour la prochaine ronde.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} completada. Haga check-in de jugadores para la siguiente ronda.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} completa. Faça check-in dos jogadores para a próxima rodada.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} completato. Fai check in dei giocatori per il prossimo round.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} complete. Check in players for the next round.`)
});